import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

class AddAbacusCourse extends Component {
  state = {
    title: "",
    description: "",
    duration: "",
    redirect: false,
    notification: {
      open: false,
      color: "success",
      message: "",
    },
  };

  componentDidMount() {
    if (init() !== "success") {
      this.setState({ redirect: true });
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = () => {
    const { title, description, duration } = this.state;

    if (!title || !duration) {
      this.setState({
        notification: {
          open: true,
          color: "error",
          message: "Title and Duration are required",
        },
      });
      return;
    }

    axios
      .post(Constants.postUrls.createAbacusCourse, {
        title,
        description,
        duration,
      })
      .then((res) => {
        if (res.data.status === "success") {
          this.setState({
            notification: {
              open: true,
              color: "success",
              message: res.data.message,
            },
          });

          setTimeout(() => {
            this.setState({ redirect: true });
          }, 1500);
        }
      })
      .catch(() => {
        this.setState({
          notification: {
            open: true,
            color: "error",
            message: "Failed to create course",
          },
        });
      });
  };

  render() {
    const { redirect, notification } = this.state;

    if (redirect) {
      return <Navigate to="/abacuscourse" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Abacus Course
              </MDTypography>
            </MDBox>

            <MDBox p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Course Title"
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Description"
                    name="description"
                    value={this.state.description}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Duration (e.g. 3 Months)"
                    name="duration"
                    value={this.state.duration}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12} align="right">
                  <MDButton color="info" onClick={this.handleSubmit}>
                    Add Course
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>

          <MDSnackbar
            open={notification.open}
            color={notification.color}
            icon="notifications"
            title="Abacus Course"
            content={notification.message}
            dateTime="Just now"
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}

export default AddAbacusCourse;
